$(document).ready(function() {
	$('.bio-readmore').readmore({
		speed: 75,
		lessLink: '<a href="javascript:;">Voir moins</a>',
		moreLink: '<a href="javascript:;">Voir plus</a>',
		collapsedHeight:120
	});
	$('.ib').tooltip();

	$('.thumbnail').hover(
		function(){
			$(this).find('.caption').slideDown(250); //.fadeIn(250)
		},
		function(){
			$(this).find('.caption').slideUp(250); //.fadeOut(205)
		}
	);
});